module.exports = __webpack_public_path__ + "img/lookbook_3_left.eb6607eb.png";